import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import * as Fa from "react-icons/fa";
import Loader from "../../Components/Loader";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ServiceInvoice from "../ServiceInvoice/ServiceInvoice";
import {
    createAPIEndpointServiceInvoice,
    EndpointServiceInvoice,
} from "../../Services/ServiceInvoice/ServiceInvoiceService";

const UrbanAlldata = () => {
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const nav = useNavigate();

    const auth = storage.getLocal("user");
    const [endDate, setEndDate] = useState(new Date());
    const [loading, setLoading] = useState(false);
    const [showInvoice, setShowInvoice] = useState(false);
    const [surePopup, setSurePopup] = useState(false);
    const [RowDataCancel, setRowDataCancel] = useState();
    const [InvhId , setInvhId ] = useState();
    const [allRecordsData, setGetAllRecords] = useState([]);
    const [printData, setPrintData] = useState([]);
    const getAllRecords = async () => {
        setLoading(true);
        const formattedStartDate = new Intl.DateTimeFormat("en-GB").format(
            startDate,
        );
        const formattedEndDate = new Intl.DateTimeFormat("en-GB").format(endDate);
        try {
            const response = await createAPIEndpointServiceInvoice().get(
                `${EndpointServiceInvoice.GetAllSerInv}?FromDate=${formattedStartDate}&ToDate=${formattedEndDate}&strtype=U&CompId=${auth?.CompId}`,
            );
            setGetAllRecords(response.data.Data);
            setLoading(false);
        } catch (err) {
            console.log("Error ", err);
            setLoading(false);
        }
    };

    const ServiceInvoiceDetailsPage = () => {
        nav("/salesmanagement/urbanserviceinvdetails");
    };
    const rowClassName = (data) => (isSelectable(data) ? "p-disabled" : "");
    const isSelectable = (data) => data?.STATUS == "CN";

    useEffect(() => {
        getAllRecords();
    }, []);

    const handleRetry = async (rowData) => {
        const Payload = {
            compId: auth.CompId,
            userId: auth.UserId,
            invhId: rowData?.MASK_INVH_ID,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvIRPUserPassword: auth?.EInvIRPUserPassword,
            eInvGSTNO: auth?.EInvGSTNO,
            SuppId: rowData?.SUPP_ID,
        };
        try {
            const response = await createAPIEndpointServiceInvoice().post(
                `${EndpointServiceInvoice.UrbanRetryEInv}`,
                Payload,
            );
            console.log("response", response);
            toast.success(`${response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
            getAllRecords();
        } catch (err) {
            setLoading(false);
            console.log("Error ", err);
            toast.error(`${err.response.data.Message}`, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        }
    };

    const renderRetryButton = (rowData) => {
        if (rowData?.GST_NO && rowData.E_INV_FLAG === "N") {
            return (
                <button
                    className="grid-icon"
                    title="Retry E-Invoice"
                    onClick={() => handleRetry(rowData)}
                >
                    <Fa.FaRedo />
                </button>
            );
        }

        return null;
    };

    // const renderRetryButton = (rowData) => {
    //         // 🔹 R-specific override
    //         if (strType === "R") {
    //             if ((rowData?.GST_NO !== null && rowData?.GST_NO !== "") && rowData.E_INV_FLAG === "N") {
    //                 // Show Retry button
    //                 return (
    //                     <button
    //                         className="grid-icon"
    //                         title="Retry"
    //                         onClick={() => handleRetry(rowData)}
    //                     >
    //                         <Fa.FaRedo />
    //                     </button>
    //                 );
    //             } else {
    //                 // Don't show Retry for other "R" cases
    //                 return null;
    //             }
    //         }
    
    //         // 🔹 Fallback to your existing Retry logic (unchanged)
    //         if (rowData?.E_INV_FLAG === "N") {
    //             return (
    //                 <button
    //                     className="grid-icon"
    //                     title="Retry E-Invoice"
    //                     onClick={() => handleRetry(rowData)}
    //                 >
    //                     <Fa.FaRedo />
    //                 </button>
    //             );
    //         }
    
    //         return null;
    //     };

    const renderPrintButton = (rowData) => {
        if (
            rowData?.GST_NO !== null &&
      rowData?.GST_NO !== "" &&
      rowData.E_INV_FLAG === "N"
        ) {
            return null;
        } else if (rowData?.STATUS === "CN") {
            return null;
        } else {
            return (
                <button
                    className="grid-icon"
                    title="Print"
                    onClick={() => handlePrint(rowData, "N")}
                >
                    <Fa.FaPrint />
                </button>
            );
        }
    };

    const handlePrint = async (rowData) => {
        setInvhId(rowData?.MASK_INVH_ID);
        setLoading(true);
        const payload = {
            invhId: rowData?.MASK_INVH_ID,
            eInvApplicability: auth?.EInvApplicability,
            ServiceType: "U",
        };
        try {
            const response = await createAPIEndpointServiceInvoice().post(
                `${EndpointServiceInvoice.PrintServiceInv}`,
                payload,
            );
            setPrintData(response.data);
            setShowInvoice(true);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log("Error ", err);
        }
    
    };
    const renderCancelButton = (rowData) => {
        console.log("Console", rowData);

        const invhDateStr = rowData?.INVH_DATE;
        if (!invhDateStr) return null;

        // Expecting format: dd/MM/yyyy
        const parts = invhDateStr.split("/");
        if (parts.length !== 3) return null;

        const [day, month, year] = parts.map(Number);
        const invoiceDate = new Date(year, month - 1, day); // safer cross-browser
        const today = new Date();

        const diffInMs = today.getTime() - invoiceDate.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

        // Skip if invoice is cancelled
        if (rowData?.STATUS === "CN") return null;

        // Skip if invoice is older than 30 days
        if (diffInDays > 30) return null;

        // GST-based conditions
        if (rowData?.GST_NO && rowData.GST_NO.trim() !== "") {
            if (rowData?.E_INV_FLAG === "N") return null;
            if (diffInDays > 1) return null;
        }

        return (
            <button className="grid-icon">
                <Fa.FaTimes
                    className="cancel"
                    onClick={() => {
                        setSurePopup(true);
                        setRowDataCancel(rowData);
                    }}
                />
            </button>
        );
    };
    const renderViewButton = (rowData) => (
        <button
            className="grid-icon"
            title="View"
            onClick={() =>
                nav(
                    `/salesmanagement/urbanserviceinvdetails?id=${rowData?.MASK_INVH_ID}`,
                )
            }
        >
            <Fa.FaEye />
        </button>
    );

    const onCancelInvoice = async () => {
        if (!RowDataCancel) return;

        console.log("RowData", RowDataCancel);
        setLoading(true);

        const payload = {
            compId: auth.CompId,
            userId: auth.UserId,
            invhId: RowDataCancel?.MASK_INVH_ID,
            sI_Tag: "U",
            suppId: RowDataCancel?.SUPP_ID,
            eInvIRPUserId: auth.EInvIRPUserId,
            eInvIRPUserPassword: auth?.EInvIRPUserPassword,
            eInvGSTNO: auth?.EInvGSTNO,
        };

        try {
            const api = createAPIEndpointServiceInvoice();
            const { data } = await api.post(
                `${EndpointServiceInvoice.CancelUrbanServiceInvoice}`,
                payload,
            );

            toast.success(data?.Message, {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });

            getAllRecords();
        } catch (err) {
            toast.error(err.response?.data?.Message || "Something went wrong", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 2000,
            });
        } finally {
            setLoading(false);
            setSurePopup(false);
        }
    };

    return (
        <>
            {loading ? <Loader /> : null}
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Urban Service Invoice</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="float-end mb-2">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={ServiceInvoiceDetailsPage}
                            >
                Add New
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <form>
                        <div className="row d-flex justify-content-end align-items-end">
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.value)}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                />
                            </div>
                            <div className="col-lg-4 col-md-6 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.value)}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                />
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12">
                                <div className="text-end">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={getAllRecords}
                                    >
                    Get Urban Invoices
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
                <section className="mt-3">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3>Records</h3>
                            <div className="DataTable pt-1 pb-4">
                                <DataTable
                                    value={allRecordsData}
                                    paginator
                                    rows={10}
                                    responsiveLayout="scroll"
                                    dataKey="MASK_INVH_ID"
                                    rowClassName={rowClassName}
                                    rowSelectable={(rowData) => rowData.STATUS !== "OP"}
                                >
                                    <Column field="INVH_NO" header="Invoice No." />
                                    <Column field="INVH_DATE" header="Invoice Date" />
                                    <Column field="SUPP_NAME" header="Urban RSE Name" />
                                    <Column field="STATUS_MSG" header="Status" />
                                    <Column header="Print" body={renderPrintButton} />
                                    <Column
                                        header="View"
                                        body={renderViewButton}
                                        bodyClassName="allow-interaction"
                                    />
                                    <Column header="Retry" body={renderRetryButton} />
                                    <Column header="Cancel" body={renderCancelButton} />
                                </DataTable>
                            </div>
                        </div>
                    </div>
                    {/* <button onClick={() => setShowInvoice(true)}> show Invoice </button> */}
                </section>
            </div>
            <Dialog
                header="Information"
                visible={surePopup}
                style={{ width: "50vw" }}
                // onHide={() => setSurePopup(false)}
                closable={false}
                resizable={false}
                draggable={false}
            >
                <div>
                    <p className="mb-0">Are you sure to Delete the RSE Invoice ?</p>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="float-end">
                        <button
                            type="button"
                            className="btn btn-primary me-3"
                            onClick={() => onCancelInvoice()}
                        >
              OK
                        </button>
                        <button
                            type="button"
                            className="btn btn-cancel-red"
                            onClick={() => {
                                setSurePopup(false);
                            }}
                        >
              Cancel
                        </button>
                    </div>
                </div>
            </Dialog>
            <ServiceInvoice
                DCpopup={showInvoice}
                setDCPopup={setShowInvoice}
                printData={printData}
                tag=""
                invhid={InvhId}
                strType="U"
            />
        </>
    );
};

export default UrbanAlldata;
